import React from 'react';
import { Trans } from '@lingui/macro';
import styled from 'styled-components';

import { ArrowLeft, ArrowRight, Rebook } from '@rover/icons';
import { Button, Flex } from '@rover/kibble/core';
import { DSTokenMap } from '@rover/kibble/styles';
import Checkbox from '@rover/react-lib/src/components/formFields/Checkbox';

const CheckboxLabel = styled.label`
  display: flex;
  flex-wrap: nowrap;
  padding: ${DSTokenMap.SPACE_2X};
  cursor: pointer;

  color: ${DSTokenMap.INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED.toString()};
  font-size: 14px;
`;

const StyledCheckbox = styled(Checkbox)`
  margin: ${DSTokenMap.SPACE_1X} ${DSTokenMap.SPACE_2X} 0 0;
  cursor: pointer;
`;

type Props = {
  searchOnMove: boolean;
  isExpanded: boolean;
  mapHasMoved: boolean;
  onMapChangeSearchToggle: () => void;
  onSearchThisAreaPress: () => void;
  onMapExpanderClick: () => void;
};

export default function MapControls({
  searchOnMove,
  isExpanded,
  mapHasMoved,
  onMapChangeSearchToggle,
  onSearchThisAreaPress,
  onMapExpanderClick,
}: Props): JSX.Element {
  return (
    <Flex
      background="primary"
      justifyContent="space-between"
      width="100%"
      alignItems="center"
      flexWrap="nowrap"
    >
      <Button
        onClick={onMapExpanderClick}
        variant="flat"
        size="small"
        aria-expanded={isExpanded}
        icon={isExpanded ? ArrowRight : ArrowLeft}
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        {isExpanded ? <Trans>Shrink map</Trans> : <Trans>Enlarge map</Trans>}
      </Button>
      {searchOnMove || !mapHasMoved ? (
        <CheckboxLabel>
          <StyledCheckbox
            onChange={onMapChangeSearchToggle}
            value="address"
            checked={searchOnMove}
          />
          <Trans>Update when I move the map</Trans>
        </CheckboxLabel>
      ) : (
        <Button
          variant="flat"
          size="small"
          icon={Rebook}
          sx={{
            whiteSpace: 'nowrap',
          }}
          onClick={onSearchThisAreaPress}
        >
          <Trans>Update search results</Trans>
        </Button>
      )}
    </Flex>
  );
}
